import { FC } from 'react';
import classNames from 'classnames';
import {
  creditCardTransactionsStore,
  setActiveSelectedCreditCard,
  setIsUserAddedCreditCardWithMasterpass,
  setUserTemporaryCreditCard,
} from 'Stores/CreditCardTransactions';
import { Box } from '@material-ui/core';
import { gutters } from 'Theme/Variables';
import { useCreditCardType } from 'Hooks';
import { maskCreditCardNumber } from 'Utils';
import { resetFormError } from 'Stores/Form';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronDarkRightIcon, TickIcon } from 'Components';
import './SelectedPaymentMethod.scss';

type SelectedPaymentMethodProps = {
  paymentMethodItem: any;
  hide: Function;
  isDialog: boolean;
  logoUrl?: string;
  brandUrl?: string;
  isSelected?: boolean;
  onSelect?: (paymentMethod: any) => void;
};

const SelectedPaymentMethod: FC<SelectedPaymentMethodProps> = ({
  paymentMethodItem,
  hide,
  isDialog,
  logoUrl,
  brandUrl,
  isSelected = false,
  onSelect,
}) => {
  const dispatch = useDispatch();

  // To show green border check if addedTemporary card is the same with selected card
  const { userTempCreditCard, activeSelectedCreditCard } = useSelector(creditCardTransactionsStore);

  // Because of using the same component if logo and brand url doesnt come use this
  const { creditCardBrandUrl, creditCardLogoUrl } = useCreditCardType(paymentMethodItem);

  const handleClick = () => {
    if (onSelect) {
      onSelect(paymentMethodItem);
    } else {
      dispatch(setActiveSelectedCreditCard(paymentMethodItem));
    }
    if (isDialog) {
      dispatch(resetFormError());
      dispatch(setIsUserAddedCreditCardWithMasterpass(false));
      dispatch(setUserTemporaryCreditCard(undefined));
      hide();
    }
  };

  return (
    <div
      id="selectedPaymentMethod"
      onClick={handleClick}
      itemID="choosePaymentMethodToPaymentStepBtnTest"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); } }}
    >
      <Box
        className={classNames({
          selectedPaymentMethod__container: true,
          'selectedPaymentMethod__container--active': isSelected,
          'selectedPaymentMethod--addedTempCard': userTempCreditCard && !isDialog,
        })}
      >
        <Box display="flex" alignItems="center">
          <Box marginRight={gutters.regular} width={66}>
            <img src={logoUrl ? logoUrl : creditCardLogoUrl} alt="" className="selectedPaymentMethod--cardLogo" />
          </Box>
          <Box display="flex" justifyContent="center" alignItems="flex-start" flexDirection="column" flex={1}>
            {paymentMethodItem?.cardAlias && <Box className="selectedPaymentMethod--title">{paymentMethodItem?.cardAlias}</Box>}
            {paymentMethodItem?.maskedCardNumber && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Box className="selectedPaymentMethod--cardNumber">
                  {maskCreditCardNumber(paymentMethodItem?.maskedCardNumber)}
                </Box>
                <span className="selectedPaymentMethod--dot" />
                <img className="selectedPaymentMethod--brand" src={brandUrl ? brandUrl : creditCardBrandUrl} alt="" />
              </Box>
            )}
          </Box>
        </Box>
        {isDialog && isSelected && <TickIcon />}
        {!isDialog && <ChevronDarkRightIcon />}
      </Box>
    </div>
  );
};

export default SelectedPaymentMethod;
export { SelectedPaymentMethod };
